export var defaultTitleFontFamily = 'Poppins';
export var titleFontThemes = {sourceSans:'c5-19-3_y171sh1',notoSerif:'c5-19-3_y171sh2',lato:'c5-19-3_y171sh3',montserrat:'c5-19-3_y171sh4',openSans:'c5-19-3_y171sh5',raleway:'c5-19-3_y171sh6'};
export var titleFontVars = {fontFamily:'var(--c5-19-3_y171sh0)'};